import React from 'react';
import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';
import { AlignJustify, LayoutGrid } from 'lucide-react';

interface ViewToggleProps {
  viewMode: string;
  onViewModeChange: (mode: string) => void;
  className?: string;
  mood?: 'light' | 'dark';
}

export const ViewToggle: React.FC<ViewToggleProps> = ({
  viewMode,
  onViewModeChange,
  className = '',
  mood = 'light',
}) => (
  <Tabs value={viewMode} onValueChange={onViewModeChange}>
    <TabsList className={`border border-primary rounded-lg flex ${className}`}>
      <TabsTrigger value="list" className={`h-10 w-10 ${mood === 'dark' ? 'data-[state=active]:bg-[#fff0d040]' : 'data-[state=active]:bg-primary-25'}`}>
        <AlignJustify className="h-4 w-4" />
      </TabsTrigger>
      <TabsTrigger value="grid" className={`h-10 w-10 ${mood === 'dark' ? 'data-[state=active]:bg-[#fff0d040]' : 'data-[state=active]:bg-primary-25'}`}>
        <LayoutGrid className="h-4 w-4" />
      </TabsTrigger>
    </TabsList>
  </Tabs>
);
